import { inject, injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";
import { ScratchGame } from "src/containers/wellbeing/rewards/domain/models/scratch-game";
import { ScratchGameService } from "src/containers/wellbeing/rewards/services/scratch-game-service/scratch-game-service";

@injectable()
export class WellbeingRewardsListViewModel {
    constructor(
        @inject("ScratchGameService") private service: ScratchGameService
    ) {}

    @autoBind
    getAllGames(userIdentity: string, useMock = false): Promise<ScratchGame[]> {
        return this.service.getGames(userIdentity, useMock);
    }
}
